import React, { useEffect, useState } from 'react';
import TextWinds from '../../../../components/common/TextWinds';
import {
  AppProductListOrderBy,
  ProductSubType,
  ProductType,
} from '../../../../enum';
import { BoostUpTypes, LmsInfoTypes } from '../../../../constants/types';
import BoostupWidget from '../../../../components/boostup/BoostupWidget';
import instance from '../../../../api/axios/utils.ts/instance';

const BoostUp = ({
  lmsLists,
  classId,
}: {
  lmsLists: LmsInfoTypes;
  classId: string;
}) => {
  const [boostupLists, setBoostupLists] = useState<BoostUpTypes[]>([]);
  const params = {
    product_type: ProductType.BOOSTUP,
    product_sub_type: ProductSubType.PRODUCT,
    order_by: AppProductListOrderBy.RECOMMENDED,
    courseId: lmsLists.course?.id,
  };
  useEffect(() => {
    if (lmsLists.course) {
      const fetchBoostupLists = async () => {
        try {
          await instance.get('/v1/product', { params }).then((response) => {
            setBoostupLists(response.data.result);
          });
        } catch (error) {}
      };

      fetchBoostupLists();
    }
  }, [classId]);

  const isLoading = (): boolean => {
    if (!boostupLists) {
      return true;
    } else {
      return false;
    }
  };

  // 부스트업 리스트가 없거나 길이가 0이면 컴포넌트를 렌더링하지 않음
  if (isLoading() || !boostupLists || boostupLists.length === 0) {
    return null;
  }

  return (
    <div className="rounded-lg bg-white px-3 pt-6 shadow-card xl:px-8">
      <div className="relative mb-3 flex items-center justify-between">
        <TextWinds type="title_h4" xlType="title_h3">
          부스트업 (코스 운영 상품)
        </TextWinds>
      </div>

      <div className="mb-5 rounded bg-gray1 p-4 xl:mb-[34px] xl:px-5 xl:py-[14px]">
        <TextWinds type="caption1" color="gray8">
          본 코스를 수료 후 운영 기간 중에 계신 선생님만 구매할 수 있는
          상품입니다.
        </TextWinds>
      </div>
      <div className="grid h-auto grid-cols-2 gap-x-[15px] gap-y-[23px] pb-8 xl:grid-cols-5 xl:gap-x-6 xl:gap-y-6">
        <BoostupWidget classId={classId} datas={boostupLists} />
      </div>
    </div>
  );
};

export default BoostUp;
